import React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './CriteriaCard.styles';
import {
  CRITERIA_OPTIONS,
  CRITERIA_TAG_OPTIONS,
  CRITERIA_TAG_PROPERTY_OPTIONS
} from '../../../constants/triggers';

import Button from '../../inputs/button/Button';

const CriteriaCard = props => {
  if (!props.criteria) {
    return;
  }
  return (
    <div className={css(styles.base)}>
      <div className={css(styles.text)}>
        <Translate
          value={CRITERIA_TAG_PROPERTY_OPTIONS[props.criteria.compareBy].text}
          type={I18n.t(CRITERIA_OPTIONS[props.criteria.type].label)}
          property={I18n.t(CRITERIA_TAG_OPTIONS[props.criteria.property].label)}
          compareBy={I18n.t(
            CRITERIA_TAG_PROPERTY_OPTIONS[props.criteria.compareBy].label
          )}
          compareTo={
            props.criteria.compareTo
              ? props.criteria.compareTo.name || props.criteria.compareTo
              : ''
          }
        />
      </div>
      <div className={css(styles.buttonContainer)}>
        {props.showAnd && (
          <Button
            type="button"
            styles={styles.andButton}
            onClick={props.onAndClick}
          >
            <Translate value="and" />
          </Button>
        )}
        <Button
          type="button"
          styles={styles.button}
          onClick={props.onEditClick}
        >
          <Translate value="edit.edit" />
        </Button>
        <Button
          type="button"
          styles={styles.button}
          onClick={props.onDeleteClick}
        >
          <Translate value="delete.delete" />
        </Button>
      </div>
    </div>
  );
};

export default CriteriaCard;



// WEBPACK FOOTER //
// ./src/components/data/criteriacard/CriteriaCard.js